<div *ngIf="showIntro" class="intro">
  <div class="content-logo">
    <img proLogoImg alt="logo" class="content-logo__logo">
  </div>
  <div>
    <div class="content__description">
      <p *ngIf="isVisibleIntroText" class="content__description--text">
        {{this.texts.intro}}
      </p>
    </div>
    <div class="content__header">
      <p class="content__header--title">{{this.texts.title}}
      </p>
      <div class="content__header--languages" *ngIf="showLanguageSelector | async">
        <app-languages [selectedLang]="languageService.lang" [forceReload]="false"></app-languages>
      </div>
    </div>
    <div class="content">
      <div>
        <ul class="content__ul-list">
          <ng-container *ngIf="texts.titleStep1 && texts.descriptionStep1">
            <li class="content__list" id="sectionSeparator">
              <div class="content__list--all">
                <div class="content__list--content">
                  <p class="content__list--step-title">1. {{ this.texts.titleStep1 }}</p>
                  <div class="content__list__containerDescription">
                    <p class="content__list--step-description">
                      {{ texts.descriptionStep1 }}
                    </p>
                  </div>
                </div>
              </div>
            </li>
          </ng-container>

          <ng-container *ngIf="texts.titleStep2 && texts.descriptionStep2">
            <li class="content__list">
              <div class="content__list--all" id="sectionSeparator">
                <div class="content__list--content">
                  <p class="content__list--step-title">2. {{ texts.titleStep2 }}</p>
                  <div class="content__list__containerDescription">
                    <p class="content__list--step-description">
                      {{ texts.descriptionStep2 }}
                    </p>
                  </div>
                </div>
              </div>
            </li>
          </ng-container>

          <ng-container *ngIf="texts.titleStep3 && texts.descriptionStep3">
            <li class="content__list">
              <div class="content__list--all" id="sectionSeparator">
                <div class="content__list--content">
                  <p class="content__list--step-title">3. {{ texts.titleStep3 }}</p>
                  <div class="content__list__containerDescription">
                    <p class="content__list--step-description">
                      {{ texts.descriptionStep3 }}
                    </p>
                  </div>
                </div>
              </div>
            </li>
          </ng-container>

          <ng-container *ngIf="texts.titleStep4 && texts.descriptionStep4">
            <li class="content__list">
              <div class="content__list--all" id="sectionSeparator">
                <div class="content__list--content">
                  <p class="content__list--step-title">4. {{ texts.titleStep4 }}</p>
                  <div class="content__list__containerDescription">
                    <p class="content__list--step-description">
                      {{ texts.descriptionStep4 }}
                    </p>
                  </div>
                </div>
              </div>
            </li>
          </ng-container>
        </ul>
      </div>
      <div class="content__actions">
        <signaturit-button class="customBtn" text="{{ 'signaturit_pro.intro.exit' | translate:_transParam }}"
          type="ghost" size="md" (click)="exitProcess()">
        </signaturit-button>
        <signaturit-button class="customBtn" text="{{ 'signaturit_pro.intro.button' | translate:_transParam }}"
          type="primary" size="md" (click)="onNavigate()" [disabled]="disableAcceptButton"
          [showLoader]="disableAcceptButton">
        </signaturit-button>
      </div>
    </div>
  </div>
</div>
